/**
 * funnelBrowserStateTtl.ts — ОДИН срок жизни на всё, что воронка оставляет в
 * браузере покупателя про его текущее прохождение.
 *
 * ПОЧЕМУ СРОК ОБЩИЙ, А НЕ ПО ЧИСЛУ НА КАЖДОЕ ХРАНИЛИЩЕ. Жалоба покупателя
 * 18.09.2026 (воронка funnel.quizsomaapp.info) вскрыла класс «состояние в
 * хранилище рассогласовано»; внутри самой защиты WEB-1740 он выглядел так:
 * защита держится на ДВУХ вещах сразу — метке `?s=paywall` в адресе и следе
 * «этот браузер сам дошёл до пейволла» (`paywallStepProof.ts`), — а прогресс
 * прохождения (`quizProgressStorage.ts`) живёт сутки. След жил вечно, и через
 * неделю ссылка с меткой снова открывала экран оплаты, только снимка уже не
 * было: пейволл получал пустые ответы, и всё, что он считает по ответам
 * покупателя, выходило пустым или дефолтным — ветвление блоков по ответам с
 * вариантами (выбранная цель, выбранный тариф). WEB-2492: ответы квиза
 * доходят до встроенного пейволла отдельным чтением (`quizAnswersBridge.tsx`)
 * и питают только правила показа блоков, подстановок их текста в тексты
 * пейволла там нет.
 * Ответы, исключённые решением владельца 17.09 (почта, телефон, вес, рост,
 * имя), тут ни при чём: их в браузере нет вовсе, и подстановки по ним пусты
 * после любой перезагрузки — на это срок следа не влияет никак.
 *
 * Обе записи описывают ОДНО И ТО ЖЕ — «где человек сейчас находится в этой
 * воронке». Разные сроки у половин одного факта разъезжаются молча, поэтому
 * число здесь ровно одно: второго, которое можно забыть поправить, по
 * построению не существует.
 *
 * Срок — сутки, решение владельца по WEB-2177 (п.3 карточки).
 */
export const FUNNEL_BROWSER_STATE_TTL_MS = 24 * 60 * 60 * 1000;

/**
 * ОКНО СНИСХОЖДЕНИЯ ДЛЯ СЛЕДА, ЗАПИСАННОГО ДО ПОЯВЛЕНИЯ СРОКА (находка 1
 * свежего взгляда по этой же правке).
 *
 * ПОЧЕМУ СТАРОЙ ЗАПИСИ НЕЛЬЗЯ ВЕРИТЬ НА СУТКИ. У новой записи порядок надёжен:
 * след ставится в момент прихода на пейволл, а снимок прогресса переписывается
 * позже и на каждой загрузке — значит снимок всегда моложе следа, и «след
 * действует» означает «ответы под рукой». У записи, сделанной ДО выката,
 * отметки времени нет вовсе: её снимок мог истечь и быть снесён неделю назад.
 * Дать ей полные новые сутки — значит пустить человека по адресу с меткой
 * `?s=paywall` (он живёт в истории браузера, автоподстановке, закладках и
 * адресах возврата со Stripe) прямо на оплату с пустыми подстановками, то есть
 * ровно в тот отказ, ради которого срок и заводился.
 *
 * ПОЧЕМУ ЕЁ ВСЁ ЖЕ НЕЛЬЗЯ ВЫБРОСИТЬ СРАЗУ. В момент выката часть покупателей
 * стоит на экране оплаты прямо сейчас. Снятие следа уронило бы их
 * перезагрузку (и возврат со Stripe) на первый экран квиза — оплата на полпути
 * превращается в «пройдите заново».
 *
 * Отсюда час: перезагрузиться и вернуться с оплаты успевает каждый, кто
 * действительно находится на пейволле, а «след из прошлой недели» не оживает.
 * Срок такой записи считается от «сейчас минус (общий срок − это окно)».
 */
export const LEGACY_PAYWALL_STEP_GRACE_MS = 60 * 60 * 1000;
